module.exports = __webpack_public_path__ + "img/tomato--orange.53e02e0b.svg";